import { useState } from 'react';

import { DatePicker, Input, Modal } from '@components';
import {
  getCustomTermDueDateCalendarMin,
  getTermDueCalendarSelectedDate
} from '@features/group-management/helpers/customTerm';
import { formatISODate } from '@utils/date';

interface TermDueDateSelectionProps {
  dueDate: string;
  onDueDateChange: (date: string) => void;
  isDueDateDisabled: boolean;
  isDueDateError?: boolean;
  dueDateErrorMessage?: string;
  previousTermDueDate?: string | null;
}

const TermDueDateSelection = ({
  dueDate,
  onDueDateChange,
  isDueDateDisabled,
  isDueDateError,
  dueDateErrorMessage,
  previousTermDueDate
}: TermDueDateSelectionProps) => {
  const [isDueDateModalOpen, setIsDueDateModalOpen] = useState<boolean>(false);

  const minSelectable = getCustomTermDueDateCalendarMin(previousTermDueDate);
  const selectedForCalendar = getTermDueCalendarSelectedDate(
    dueDate,
    minSelectable
  );

  return (
    <>
      <Input
        leftIconName="calendar"
        value={
          dueDate && dueDate !== '' ? formatISODate({ date: dueDate }) : ''
        }
        onClick={() => {
          setIsDueDateModalOpen(true);
        }}
        placeholder="dd/mm/yyy"
        disabled={isDueDateDisabled}
        error={isDueDateError}
        errorMessage={dueDateErrorMessage}
        leftIconStyle={`${isDueDateDisabled ? '!opacity-50' : ''}`}
      />
      {isDueDateModalOpen && (
        <Modal
          isOpen={isDueDateModalOpen}
          onCancel={() => setIsDueDateModalOpen(false)}
        >
          <DatePicker
            confirmButtonLabel="Apply"
            confirmButtonStyle="text-primary"
            handleConfirm={(date) => {
              onDueDateChange(date);
              setIsDueDateModalOpen(false);
            }}
            cancelButtonLabel="Cancel"
            handleCancel={() => {
              setIsDueDateModalOpen(false);
            }}
            isMinDateRequired
            isMaxDateRequired={false}
            minDate={minSelectable}
            selectedDate={selectedForCalendar}
            calendarStyle="!bg-bgBase"
            title="Select Due Date"
          />
        </Modal>
      )}
    </>
  );
};

export default TermDueDateSelection;
